<script lang="ts">
  import Heading from "../../components/atoms/Heading.svelte";
  import Confirmation from "../../components/organisms/Confirmation.svelte";

  interface Props {
    confirmationContent?: string;
    seller: string;
    signId: number;
    confirmationType: "purchaseFlow" | "microProduction";
  }

  let {
    confirmationContent = undefined,
    seller,
    signId,
    confirmationType
  }: Props = $props();
</script>

{#if seller}
  {#if signId}
    <span class={"text-xl my-2 block"}>Avtals-ID på inpostat elavtal: <b>{signId}</b></span>
  {:else}
    <Heading>Hittade inte något signerings id i svaret.</Heading>
  {/if}
{/if}
<Confirmation {confirmationType} {confirmationContent} />
